import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {isEmpty} from "../../../components/commonmethod/CommonMethod";
import {
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailFormPageShell,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import Th_title from "../../../components/Th_title";
import {useDispatch, useSelector} from "react-redux";
import {apiLoading, skeleton} from "../../../redux/slice/apiSlice";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import dayjs from "dayjs";
import SimmsInput from "../../../components/input/SimmsInput";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import {handleActiveError} from "../../../components/sonner/ToastBasic";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import {CodeSpecNum} from "../../../constant/CodeSpecNum";
import {saveIntroduction} from "../../../api/lifecycle/introduction/IntroductionService";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import {assetNameDuplicate} from "../../../api/asset/AssetService";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {IntroductionAssetDraftList} from "./components/IntroductionAssetDraftList";
function IntroductionCreate() {
    const formatDate = (date) => {
        const year = String(date.getFullYear()).slice(2); // 연도 마지막 두 자리
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1 필요)
        const day = String(date.getDate()).padStart(2, '0'); // 일

        return `${year}${month}${day}`;
    };

    const user = useSelector(state => state.auth.user);
    const [introduction, setIntroduction] = useState({number : formatDate(new Date()), requester : user, inspector : user, assets: []});
    const [docs, setDocs] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();
    const cancel = {
        url: "/lifecycle/introduction"
    }

    const requireds =["name","requester", "inspector", "requestCode"]
    const dispatch = useDispatch();
    const create = async () => {
        // if (!validationChecker(introduction)) return;

        if(introduction.assets.length == 0){
            alert("자산을 추가해주세요")
            return false;
        }

        if(requireds.some(e=> isEmpty(introduction[e]))){
            alert("필수값이 누락되었습니다.")
            return
        }

        dispatch(apiLoading(true));

        const docFile = []
        docs.forEach(each => docFile.push(each.object))

        const updatedData = {
            ...introduction,
            requester: {id: introduction.requester.id},
            inspector: {id: introduction.inspector.id},
            requestCode: {id: introduction.requestCode.id},
            ...(introduction.operator && { operator: { id: introduction.operator.id } }) // operator가 있을 때만 추가
        }

        await saveIntroduction(updatedData, docFile).then(response => {
            if (response.status === 200) {
                alert("등록되었습니다.")
                navigate("/lifecycle/introduction", {
                    state: {
                        test: location.state
                    }
                });
            }else if (response.status === 201 || (response.status === 202)) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if(response.status===413){
                handleActiveError({message: "첨부파일 용량이 너무 큽니다."});
            }else{
                handleActiveError({message: "등록에 실패하였습니다."});
            }
        }).finally(dispatch(apiLoading(false)));
    }

    useEffect(() => {
        dispatch(skeleton(false))
    }, [])

    // 1. asset 배열에 새 항목 추가
    const addAssets = async () => {
        // if(!introduction.operator) {
        //     alert("운영담당자를 선택해주세요")
        //     return;
        // }

        if(!introduction.assetName) {
            alert("도입자산명을 입력해주세요")
            return;
        }

        if(!introduction.group) {
            alert("자산그룹을 선택해주세요")
            return;
        }

        if(introduction.assets.length > 0 && introduction.assets.find(each => each.assetName == introduction.assetName)) {
            alert("도입자산에 동일한 자산명이 존재합니다.")
            return;
        }

        const r = await assetNameDuplicate(introduction.assetName);
        if (r.status === 201 || (r.status === 202)) {
            alert("등록된 자산에 동일한 자산명이 존재합니다.")
            return r;
        }

        setIntroduction((prev) => {
            return {
                ...prev, // group과 operator는 유지
                assets: [
                    ...prev.assets, // 기존 asset 배열
                    {
                        assetName : prev.assetName, // assetName 추가
                        groupId : prev.group.id,
                        groupName : prev.group.name
                        // operator: prev.operator // operator 상태 그대로 추가
                    }
                ]
            };
        });
    };

    // 2. asset 배열에서 특정 인덱스의 항목 삭제
    const deleteAsset = (index) => {
        setIntroduction((prev) => ({
            ...prev,
            assets: prev.assets.filter((_, i) => i !== index) // 인덱스 제외하고 새 배열 반환
        }));
    };

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="자산도입 등록"
            meta="신규 도입 요청 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/lifecycle/introduction")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailThreeColLayout
                        primary={
            <DetailPanel title="요청정보">
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title={"요청자"} colspan={3} className="fieldset-td" required auth>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setIntroduction, "requester", introduction.requester ,v)}
                                    data={introduction.requester}
                                    entity={"userAccount"}
                                    uniqueKey={'requester'}
                                >
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                    <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                    <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                </Selector>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청종류"} colspan={3} className="fieldset-td" required auth>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setIntroduction, "requestCode", introduction.requestCode ,v)}
                                    data={introduction.requestCode}
                                    entity={"code"}
                                    parentKey={CodeSpecNum.IntroductionRequestCode}
                                    recursive
                                />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청일"} colspan={3} className="fieldset-td fieldset-td-input">
                                <div className="web-flex asset-detail-date-range">
                                    <SimmsDatePicker
                                        onChange={(v)=>dateOnChange(setIntroduction,"requestStartDate", v, false)}
                                        data={introduction.requestStartDate}
                                        constraint={{lessThan : introduction.requestEndDate && dayjs(introduction.requestEndDate)}} auth />
                                    <span className="asset-detail-date-range-sep">~</span>
                                    <SimmsDatePicker
                                        onChange={(v)=>dateOnChange(setIntroduction,"requestEndDate", v, false)}
                                        data={introduction.requestEndDate}
                                        constraint={{largerThan : introduction.requestStartDate && dayjs(introduction.requestStartDate)}} auth />
                                </div>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"요청번호"} colspan={3} className="fieldset-td">
                                <ReadOnlyInputBasic target={"number"} value={introduction.number} />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"검수자"} colspan={3} className="fieldset-td" auth required>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setIntroduction, "inspector", introduction.inspector ,v)}
                                    data={introduction.inspector}
                                    entity={"userAccount"}
                                    uniqueKey={'inspector'}
                                >
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                    <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                    <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                </Selector>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"제목"} colspan={3} className="fieldset-td" auth required>
                                <SimmsInput onChange={(v)=>inputOnChange(setIntroduction,"name", v, true)} data={introduction.name} style={{width: "100%"}} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"내용"} colspan={3} className="fieldset-td" auth>
                                <SimmsTextArea onChange={(v)=>inputOnChange(setIntroduction,"content", v, false)}
                                               style={{width: "100%", minHeight: "80px"}}
                                               data={introduction.content} />
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"기타"} colspan={3} className="fieldset-td" auth>
                                <SimmsTextArea onChange={(v)=>inputOnChange(setIntroduction,"etc", v, false)}
                                               style={{width: "100%", minHeight: "80px"}}
                                               data={introduction.etc} />
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
                        }
                        secondary={
            <DetailPanel title="자산정보">
                <DetailKvTable>
                    <tbody>
                        <tr>
                            <Th_title title={"운영담당자"} colspan={3} className="fieldset-td" auth>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setIntroduction, "operator", introduction.operator ,v)}
                                    data={introduction.operator}
                                    entity={"userAccount"}
                                    uniqueKey={'operator'}
                                >
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                    <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                    <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                </Selector>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"자산그룹"} colspan={3} className="fieldset-td" auth required>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setIntroduction, "group", introduction.group ,v)}
                                    data={introduction.group}
                                    entity={"code"}
                                    parentKey={CodeSpecNum.AssetGroupCode}
                                    recursive
                                />
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"도입자산 명"} colspan={3} className="fieldset-td" auth>
                                <div className="introduction-asset-name-field">
                                    <SimmsInput onChange={(v)=>inputOnChange(setIntroduction,"assetName", v, false)} data={introduction.assetName} />
                                    <button
                                        type="button"
                                        className="introduction-asset-name-field__add shrink-0"
                                        onClick={addAssets}
                                    >
                                        추가
                                    </button>
                                </div>
                            </Th_title>
                        </tr>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"자산내역"} colspan={3} className="fieldset-td align-top">
                                <IntroductionAssetDraftList
                                    assets={introduction.assets}
                                    onRemove={deleteAsset}
                                />
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
                        }
                        aside={
                            <DetailFilePanel
                                title="첨부"
                                isEditing
                                pendingFiles={{files: docs, setFiles: setDocs}}
                                pendingInputId="introduction_create_doc"
                            />
                        }
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {IntroductionCreate}